@if(accountService.user != null) {
<nav class="navbar">
  <div class="navbar-container">
    <button class="hamburger" type="button" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen"
      aria-label="Toggle navigation">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <a routerLink="/hours" class="logo" (click)="closeAllMenus()">
      <img src="/logo.png" alt="Company Logo" />
    </a>

    <span class="nav-divider"></span>

    <ul class="nav-links">
      <li class="nav-item" routerLinkActive="active">
        <a routerLink="/hours">Hours</a>
      </li>

      <li class="nav-item" routerLinkActive="active">
        <a routerLink="/offtime">Off Time</a>
      </li>

      @if (isAdmin) {
      <li class="nav-item has-dropdown" [class.open]="submenuOpen === 'timesheets'">
        <button type="button" class="nav-link-btn" (click)="toggleSubmenu('timesheets', $event)">
          Timesheets
          <span class="nav-chevron" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </button>

        <ul class="dropdown" (click)="$event.stopPropagation()">
          <li><a routerLink="/timesheets" (click)="closeAllMenus()">Weekly Report</a></li>
          <li><a routerLink="/timesheets/admin" (click)="closeAllMenus()">3-Week Report</a></li>
          <li><a routerLink="/timesheets/daily-punches" (click)="closeAllMenus()">Daily Punches</a></li>
        </ul>
      </li>

      <li class="nav-item" routerLinkActive="active">
        <a routerLink="/employees">Employees</a>
      </li>

      <li class="nav-item" routerLinkActive="active">
        <a routerLink="/scheduling/schedule-groups">Schedules</a>
      </li>
      }
    </ul>

    <div class="right-actions">
      @if (isAdmin) {
      <button type="button" class="settings-button" [class.open]="settingsOpen" (click)="toggleSettingsPanel($event)"
        aria-label="Open settings">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 7h10" />
          <path d="M18 7h2" />
          <circle cx="16" cy="7" r="2" />
          <path d="M4 17h2" />
          <path d="M10 17h10" />
          <circle cx="8" cy="17" r="2" />
        </svg>
      </button>

      <div class="settings-backdrop" *ngIf="settingsOpen" (click)="closeAllMenus()"></div>

      <div class="settings-panel" *ngIf="settingsOpen" (click)="$event.stopPropagation()">
        <div class="panel-header">
          <div>
            <p class="panel-title">Settings</p>
            <p class="panel-subtitle">Application management &amp; configuration</p>
          </div>

          <button type="button" class="panel-close" (click)="closeAllMenus()" aria-label="Close settings">
            ×
          </button>
        </div>

        <div class="settings-grid">
          <a class="settings-tile" routerLink="/settings/application" (click)="closeAllMenus()">
            <span class="tile-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 7h10" />
                <path d="M18 7h2" />
                <circle cx="16" cy="7" r="2" />
                <path d="M4 17h2" />
                <path d="M10 17h10" />
                <circle cx="8" cy="17" r="2" />
              </svg>
            </span>
            <span>
              <strong>Application Config</strong>
              <small>System preferences &amp; config</small>
            </span>
          </a>

          <a class="settings-tile" routerLink="/settings/planning" (click)="closeAllMenus()">
            <span class="tile-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <path d="M16 2v4" />
                <path d="M8 2v4" />
                <path d="M3 10h18" />
                <path d="M8 14h.01" />
                <path d="M12 14h.01" />
                <path d="M16 14h.01" />
                <path d="M8 18h.01" />
                <path d="M12 18h.01" />
                <path d="M16 18h.01" />
              </svg>
            </span>
            <span>
              <strong>Planning</strong>
              <small>Shift planning &amp; workforce</small>
            </span>
          </a>

          <a class="settings-tile" routerLink="/settings/accruals/policies" (click)="closeAllMenus()">
            <span class="tile-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M3 17l6-6 4 4 8-8" />
                <path d="M14 7h7v7" />
              </svg>
            </span>
            <span>
              <strong>Accruals</strong>
              <small>PTO, sick time &amp; balances</small>
            </span>
          </a>

          <a class="settings-tile" routerLink="/settings/payroll/payroll-sync" (click)="closeAllMenus()">
            <span class="tile-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2v20" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </span>
            <span>
              <strong>Payroll</strong>
              <small>Pay rates &amp; integrations</small>
            </span>
          </a>

          <a class="settings-tile" routerLink="/settings/device-management" (click)="closeAllMenus()">
            <span class="tile-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="4" y="5" width="16" height="11" rx="2" />
                <path d="M8 21h8" />
                <path d="M12 16v5" />
              </svg>
            </span>
            <span>
              <strong>Device Management</strong>
              <small>Clocks, kiosks &amp; terminals</small>
            </span>
          </a>

          <a class="settings-tile" routerLink="/settings/reports" (click)="closeAllMenus()">
            <span class="tile-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 20V10" />
                <path d="M12 20V4" />
                <path d="M19 20v-7" />
              </svg>
            </span>
            <span>
              <strong>Reports</strong>
              <small>Custom &amp; scheduled reports</small>
            </span>
          </a>
        </div>
      </div>
      }

      <div class="user-menu-item" [class.open]="submenuOpen === 'user'">
        <button type="button" class="user-initials-btn" [ngClass]="userEmployeeColorClass" (click)="toggleSubmenu('user', $event)">
          <span class="initials-text">{{ userInitials }}</span>

          <span class="notification-badge" *ngIf="notificationCount$ | async as count">
            {{ count > 99 ? '99+' : count }}
          </span>
        </button>

        <ul class="dropdown user-dropdown" (click)="$event.stopPropagation()">
          <li class="user-dropdown-header">
            <div class="user-dropdown-name">{{ userFullName || userInitials }}</div>
            <div class="user-dropdown-email">{{ userEmail }}</div>
          </li>

          <li>
            <a routerLink="/notifications" (click)="closeAllMenus()">
              <span class="menu-icon bell-icon"></span>
              Notifications
            </a>
          </li>

          <li>
            <a routerLink="/change-password" (click)="closeAllMenus()">
              <span class="menu-icon lock-icon"></span>
              Change Password
            </a>
          </li>

          <li class="dropdown-divider"></li>

          <li>
            <a class="danger" (click)="closeAllMenus(); accountService.logout()">
              <span class="menu-icon logout-icon"></span>
              Log out
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="mobile-backdrop" *ngIf="menuOpen" (click)="closeAllMenus()"></div>

  <aside class="mobile-menu" [class.open]="menuOpen">
    <div class="mobile-header">
      <a routerLink="/hours" class="logo" (click)="closeAllMenus()">
        <img src="/logo.png" alt="Company Logo" />
      </a>

      <button type="button" class="mobile-close" (click)="closeAllMenus()" aria-label="Close navigation">×</button>
    </div>

    <ul class="mobile-menu-list">
      <li><a routerLink="/hours" (click)="closeAllMenus()">Hours</a></li>
      <li><a routerLink="/offtime" (click)="closeAllMenus()">Off Time</a></li>

      @if (isAdmin) {
      <li class="mobile-group" [class.open]="mobileTimesheetsOpen">
        <button type="button" class="mobile-group-toggle" (click)="toggleMobileTimesheets($event)">
          <span>Timesheets</span>
          <span class="chevron">⌄</span>
        </button>

        <ul class="mobile-submenu" *ngIf="mobileTimesheetsOpen">
          <li><a routerLink="/timesheets" (click)="closeAllMenus()">Weekly Report</a></li>
          <li><a routerLink="/timesheets/admin" (click)="closeAllMenus()">3-Week Report</a></li>
          <li><a routerLink="/timesheets/daily-punches" (click)="closeAllMenus()">Daily Punches</a></li>
        </ul>
      </li>

      <li><a routerLink="/employees" (click)="closeAllMenus()">Employees</a></li>
      <li><a routerLink="/scheduling/schedule-groups" (click)="closeAllMenus()">Schedules</a></li>

      <li class="mobile-group" [class.open]="mobileSettingsOpen">
        <button type="button" class="mobile-group-toggle" (click)="toggleMobileSettings($event)">
          <span>Settings</span>
          <span class="chevron">⌄</span>
        </button>

        <ul class="mobile-submenu" *ngIf="mobileSettingsOpen">
          <li><a routerLink="/settings/application" (click)="closeAllMenus()">Application Config</a></li>
          <li><a routerLink="/settings/planning" (click)="closeAllMenus()">Planning</a></li>
          <li><a routerLink="/settings/accruals/policies" (click)="closeAllMenus()">Accruals</a></li>
          <li><a routerLink="/settings/payroll/payroll-sync" (click)="closeAllMenus()">Payroll</a></li>
          <li><a routerLink="/settings/device-management" (click)="closeAllMenus()">Device Management</a></li>
          <li><a routerLink="/settings/reports" (click)="closeAllMenus()">Reports</a></li>
        </ul>
      </li>
      }
    </ul>

    <div class="mobile-profile">
      <button type="button" class="mobile-profile-row" (click)="toggleUserMenu($event)">
        <span class="mobile-user-badge" [ngClass]="userEmployeeColorClass">
          {{ userInitials }}

          <span class="notification-badge mobile" *ngIf="notificationCount$ | async as count">
            {{ count > 99 ? '99+' : count }}
          </span>
        </span>

        <span class="mobile-profile-label">Account</span>
        <span class="chevron">⌄</span>
      </button>

      <ul class="mobile-submenu profile-submenu" *ngIf="mobileUserMenuOpen">
        <li><a routerLink="/notifications" (click)="closeAllMenus()">Notifications</a></li>
        <li><a routerLink="/change-password" (click)="closeAllMenus()">Change Password</a></li>
        <li><a class="danger" (click)="closeAllMenus(); accountService.logout()">Log out</a></li>
      </ul>
    </div>
  </aside>
</nav>
}